<template>
  <ion-fab vertical="bottom" horizontal="end" slot="fixed">
    <ion-fab-button
      color="lion-rojo"
      :disabled="loadData"
      @click="$emitter.emit('open-fpl')"
    >
      <i
        class="mdi mdi-36px"
        :class="!loadData ? 'mdi-shopping' : 'mdi-timer-sand  mdi-spin'"
      ></i>
    </ion-fab-button>
  </ion-fab>
</template>
<script>
import { actionSheetController, modalController } from '@ionic/vue'
export default {
  data(vm) {
    return {
      loadData: false
    }
  },
  created() {},
  beforeUnmount() {},
  mounted() {},
  methods: {}
}
</script>

<style></style>
